import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import SplashScreen from './Components/SplashScreen';
import TopNotice from './Components/TopNotice';
import Navbar from './Components/Navbar';
import MainCarousel from './Components/MainCarousel';
import Feature from './Components/Feature';
import SlickCarousel from './Components/SlickCarousel';
import AboutUs from './Components/AboutUs';
import Documents from './Components/Documents';
import FeeStructure from './Components/FeeStructure';
import Facilities from './Components/Facilities';
import SchoolTiming from './Components/SchoolTiming';
import ImageGallery from './Components/ImageGallery';
import VideoGallery from './Components/VideoGallery';
import AdmissionForm from './Components/AdmissionForm';
import AdmissionStatus from './Components/AdmissionStatus';
import Disclosure from './Components/Disclosure';
import Infrastructure from './Components/Infrastructure';
import TcForm from './Components/TcForm';
import ContactUs from './Components/ContactUs';
import Footer from './Components/Footer';
import LogIn from './Components/LogIn';
import AdminNavabr from './Components/AdminNavabr';
import Dashboard from './Components/Dashboard';
import AddCarousel from './Components/AddCarousel';
import AddGallery from './Components/AddGallery';
import AddVideo from './Components/AddVideo';
import AddDocument from './Components/AddDocument';
import AddTc from './Components/AddTc'; 
import ViewEnquiry from './Components/ViewEnquiry';
import ViewAdmissions from './Components/ViewAdmissions';
import './App.css';

function App() {
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 6000);

    return () => clearTimeout(timer);
  }, []);

  if (process.env.NODE_ENV === 'production') {
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    }, false);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I')) {
        e.preventDefault();
      }
    });
  }

  return (
    <Routes>
      <Route path="/" element={
        <>
          {showSplash ?
            <SplashScreen />
            :
            <>
              <TopNotice />
              <Navbar />
              <MainCarousel />
              <Feature />
              <SlickCarousel />
              <Footer />
            </>
          }
        </>
      } />  
      <Route path="/AboutUs" element={
        <>
          {showSplash ?
            <SplashScreen />
            :
            <>
              <TopNotice />
              <Navbar />
              <AboutUs />
              <Footer />
            </>
          }
        </>
      } />  
      <Route path="/Documents" element={
        <>
          {showSplash ?
            <SplashScreen />
            :
            <>
              <TopNotice />
              <Navbar />
              <Documents />
              <Footer />
            </>
          }
        </>
      } />  
      <Route path="/FeeStructure" element={
        <>
          {showSplash ?
            <SplashScreen />
            :
            <>
              <TopNotice />
              <Navbar />
              <FeeStructure />
              <Footer />
            </>
          }
        </>
      } />  
      <Route path="/Facilities" element={
        <>
          {showSplash ?
            <SplashScreen />
            :
            <>
              <TopNotice />
              <Navbar />
              <Facilities />
              <Footer />
            </>
          }
        </>
      } />  
      <Route path="/SchoolTiming" element={
        <>
          {showSplash ?
            <SplashScreen />
            :
            <>
              <TopNotice />
              <Navbar />
              <SchoolTiming />
              <Footer />
            </>
          }
        </>
      } />  
      <Route path="/ImageGallery" element={
        <>
          {showSplash ?
            <SplashScreen />
            :
            <>
              <TopNotice />
              <Navbar />
              <ImageGallery />
              <Footer />
            </>
          }
        </>
      } />  
      <Route path="/VideoGallery" element={
        <>
          {showSplash ?
            <SplashScreen />
            :
            <>
              <TopNotice />
              <Navbar />
              <VideoGallery />
              <Footer />
            </>
          }
        </>
      } />  
      <Route path="/AdmissionForm" element={
        <>
          {showSplash ?
            <SplashScreen />
            :
            <>
              <TopNotice />
              <Navbar />
              <AdmissionForm />
              <Footer />
            </>
          }
        </>
      } />  
      <Route path="/AdmissionStatus" element={
        <>
          {showSplash ?
            <SplashScreen />
            :
            <>
              <TopNotice />
              <Navbar />
              <AdmissionStatus />
              <Footer />
            </>
          }
        </>
      } />  
      <Route path="/Disclosure" element={
        <>
          {showSplash ?
            <SplashScreen />
            :
            <>
              <TopNotice />
              <Navbar />
              <Disclosure />
              <Footer />
            </>
          }
        </>
      } />  
      <Route path="/Infrastructure" element={
        <>
          {showSplash ?
            <SplashScreen />
            :
            <>
              <TopNotice />
              <Navbar />
              <Infrastructure />
              <Footer />
            </>
          }
        </>
      } />  
      <Route path="/TcForm" element={
        <>
          {showSplash ?
            <SplashScreen />
            :
            <>
              <TopNotice />
              <Navbar />
              <TcForm />
              <Footer />
            </>
          }
        </>
      } />  
      <Route path="/ContactUs" element={
        <>
          {showSplash ?
            <SplashScreen />
            :
            <>
              <TopNotice />
              <Navbar />
              <ContactUs />
              <Footer />
            </>
          }
        </>
      } />  
      <Route path="/LogIn" element={
        <>
          {showSplash ?
            <SplashScreen />
            :
            <>
              <LogIn />
            </>
          }
        </>
      } />
      <Route path="/Dashboard" element={
        <>
          {isLoggedIn ?
            <>
              <div className='app-container'>
                <AdminNavabr />
                <Dashboard />
              </div>
            </>
            :
            <>
              {showSplash ?
                <SplashScreen />
                :
                <>
                  <TopNotice />
                  <Navbar />
                  <Footer />
                </>
              }
            </>
          }
        </>
      } />
      <Route path="/AddCarousel" element={
        <>
          {isLoggedIn ?
            <>
              <div className='app-container'>
                <AdminNavabr />
                <AddCarousel />
              </div>
            </>
            :
            <>
              {showSplash ?
                <SplashScreen />
                :
                <>
                  <TopNotice />
                  <Navbar />
                  <Footer />
                </>
              }
            </>
          }
        </>
      } />
      <Route path="/AddGallery" element={
        <>
          {isLoggedIn ?
            <>
              <div className='app-container'>
                <AdminNavabr />
                <AddGallery />
              </div>
            </>
            :
            <>
              {showSplash ?
                <SplashScreen />
                :
                <>
                  <TopNotice />
                  <Navbar />
                  <Footer />
                </>
              }
            </>
          }
        </>
      } />
      <Route path="/AddVideo" element={
        <>
          {isLoggedIn ?
            <>
              <div className='app-container'>
                <AdminNavabr />
                <AddVideo />
              </div>
            </>
            :
            <>
              {showSplash ?
                <SplashScreen />
                :
                <>
                  <TopNotice />
                  <Navbar />
                  <Footer />
                </>
              }
            </>
          }
        </>
      } />
      <Route path="/AddDocument" element={
        <>
          {isLoggedIn ?
            <>
              <div className='app-container'>
                <AdminNavabr />
                <AddDocument />
              </div>
            </>
            :
            <>
              {showSplash ?
                <SplashScreen />
                :
                <>
                  <TopNotice />
                  <Navbar />
                  <Footer />
                </>
              }
            </>
          }
        </>
      } />
      <Route path="/AddTc" element={
        <>
          {isLoggedIn ?
            <>
              <div className='app-container'>
                <AdminNavabr />
                <AddTc />
              </div>
            </>
            :
            <>
              {showSplash ?
                <SplashScreen />
                :
                <>
                  <TopNotice />
                  <Navbar />
                  <Footer />
                </>
              }
            </>
          }
        </>
      } /> 
      <Route path="/ViewEnquiry" element={
        <>
          {isLoggedIn ?
            <>
              <div className='app-container'>
                <AdminNavabr />
                <ViewEnquiry />
              </div>
            </>
            :
            <>
              {showSplash ?
                <SplashScreen />
                :
                <>
                  <TopNotice />
                  <Navbar />
                  <Footer />
                </>
              }
            </>
          }
        </>
      } />
      <Route path="/ViewAdmissions" element={
        <>
          {isLoggedIn ?
            <>
              <div className='app-container'>
                <AdminNavabr />
                <ViewAdmissions />
              </div>
            </>
            :
            <>
              {showSplash ?
                <SplashScreen />
                :
                <>
                  <TopNotice />
                  <Navbar />
                  <Footer />
                </>
              }
            </>
          }
        </>
      } />
    </Routes>
  );
}

export default App;
